<template>
  <main class="main-content bg-gradient-custom">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
              <div class="card card-plain bg-white shadow-lg">
                <div class="card-header pb-0 text-center">
                  <img src="/LogoCompleto.png" alt="Logo" class="mb-3" style="max-height: 80px;">
                  <h4 class="font-weight-bolder text-primary">Recuperar contraseña</h4>
                </div>
                <div class="card-body">
                  <form role="form" @submit.prevent="handleForgotPassword()">
                    <div class="mb-3">
                      <argon-input
                        v-model="email"
                        type="email"
                        class="mb-0"
                        placeholder="Email"
                        name="email"
                        size="lg"
                        :value="email" />
                      <validation-error :errors="apiValidationErrors.email" />
                    </div>
                    <div class="text-center">
                      <argon-button
                        type="submit"
                        class="mt-4 btn-custom"
                        color="primary"
                        fullWidth
                        size="lg"
                      >
                        <span v-if="!loading">Enviar instrucciones</span>
                        <i v-else class="fas fa-spinner fa-pulse"></i>
                      </argon-button>
                    </div>
                    <div class="text-center p-3">
                      <router-link
                        :to="{ name: 'Login' }"
                        class="text-primary font-weight-bold"
                      >Volver al inicio de sesión</router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import formMixin from "../../mixins/form-mixin.js"
import ValidationError from "../../components/ValidationError.vue";
import showSwal from "../../mixins/showSwal.js";
import Swal from 'sweetalert2';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "ForgotPassword",
  components: {
    ArgonInput,
    ArgonButton,
    ValidationError
  },
  mixins: [formMixin, showSwal],
  data() {
    return {
      email: '',
      redirect_url: 'http://localhost:8080/password/reset',
      loading: false
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods: {
    async handleForgotPassword() {
      try {
        if (this.$isDemo == 1) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'La recuperación de contraseña está desactivada en la demo.',
          });
        } else {
          this.loading = true;
          this.resetApiValidation();
          await this.$store.dispatch("auth/forgotPassword", { email: this.email, redirect_url: this.redirect_url });
          await Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: 'Se ha enviado un correo electrónico con las instrucciones para restablecer tu contraseña.',
          });
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.setApiValidation(error.response.data.errors);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ha ocurrido un error. Por favor, inténtalo de nuevo.',
        });
      }
    }
  }
};
</script>

<style scoped>
.bg-gradient-custom {
  background: linear-gradient(135deg, #706f6f 0%, #4a4949 50%, #2c2c2c 100%);
}

.card-plain {
  border-radius: 15px;
}

.text-primary {
  color: #f9b000 !important;
}

.text-secondary {
  color: #706f6f !important;
}

.btn-custom {
  background-color: #f9b000 !important;
  border-color: #f9b000 !important;
  color: #ffffff !important;
  transition: all 0.3s ease;
}

.btn-custom:hover {
  background-color: #706f6f !important;
  border-color: #706f6f !important;
}

.argon-input input {
  border: 1px solid #706f6f;
  transition: all 0.3s ease;
}

.argon-input input:focus {
  border-color: #f9b000;
  box-shadow: 0 0 0 0.2rem rgba(249, 176, 0, 0.25);
}

.card-header {
  border-bottom: 2px solid #f9b000;
}
</style>

